import { Box, Typography } from "@mui/material";
import { VIOLET } from "@/config/mui/colorPalette";
import { formattedPrice } from "@/utils";

type PackageItemsListProps = {
  items: {
    id: string;
    dollarCreditAmount?: string | null;
    itemAmount: number;
    serviceMenuItem?: {
      name: string;
    };
    product?: {
      name: string;
    };
    serviceProduct?: {
      serviceProduct: {
        name: string;
      };
    };
  }[];
  customizationPrimaryColor?: string;
};

export const PackageItemsList = ({
  items,
  customizationPrimaryColor,
}: PackageItemsListProps) => {
  const getItemName = (item: PackageItemsListProps["items"][number]) => {
    if (item.serviceMenuItem) {
      return item.serviceMenuItem.name;
    }
    if (item.product) {
      return item.product.name;
    }
    if (item.serviceProduct?.serviceProduct) {
      return item.serviceProduct.serviceProduct.name;
    }
    if (item.dollarCreditAmount) {
      return `Dollar credit: ${formattedPrice(item.dollarCreditAmount)}`;
    }
    return "";
  };

  return (
    <Box
      component="ul"
      sx={{
        listStyle: "disc",
        paddingLeft: 3,
        margin: "4px 0 0 0",
        "& li::marker": {
          color: customizationPrimaryColor
            ? customizationPrimaryColor
            : VIOLET[90],
        },
      }}
    >
      {items.map((item) => (
        <Box
          key={item.id}
          component="li"
          sx={{
            display: "list-item",
            "&:not(:last-child)": {
              marginBottom: 0.5,
            },
          }}
        >
          <Typography variant="paragraphSmall">
            {item.itemAmount > 1 ? `${item.itemAmount}x ` : ""}
            {getItemName(item)}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default PackageItemsList;
